import store from '../store'

export default async (to, from, next) => {
  await store.dispatch('ui/ActionSetLoading', true)
  if (to.name != 'Login' && !store.getters['auth/GET_token']) {
    try {
      await store.dispatch('auth/ActionCheckToken')

      await store.dispatch('employees/ActionSetBirthdays')
      await store.dispatch('employees/ActionSetContactMessageWebSite')
      await store.dispatch('employees/ActionSetEmployees')
      await store.dispatch('employees/ActionGetPaycheckEmployee')
      await store.dispatch('utils/ActionSetUtils')
      await store.dispatch('employees/ActionSetScales')
      await store.dispatch('employees/ActionSetIncomeTaxes')
      await store.dispatch('ci/ActionSetSendedIC')
      await store.dispatch('ci/ActionSetReceivedIC')
      await store.dispatch('ci/ActionSetAllIC')
      document.title = `${to.meta.name} :: IPH - Sistemas`
      next({ name: to.name })
    } catch (error) {
      next({ name: 'Login' })
      document.title = `${to.meta.name} :: IPH - Sistemas`
    }
  } else {
    if (to.name == 'Login' && store.getters['auth/GET_token']) {
      next({ name: 'Home' })
      document.title = `${to.meta.name} :: IPH - Sistemas`
    } else if (to.name == 'Login' && !store.getters['auth/GET_token']) {
      next()
    } else {
      document.title = `${to.meta.name} :: IPH - Sistemas`
      store.dispatch('auth/ActionProfile')
      next()
    }
  }
  await store.dispatch('ui/ActionSetLoading', false)
}
